import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyAQFqiE1W0_N-0BmaGgLwmTX5CB2ChX4GQ",
    authDomain: "photo-to-diag.firebaseapp.com",
    projectId: "photo-to-diag",
    storageBucket: "photo-to-diag.firebasestorage.app",
    messagingSenderId: "1027355161697",
    appId: "1:1027355161697:web:03cc6c064c71da0deea620",
    measurementId: "G-FRGR7VMWHR",
  };
  
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth, app};
